// @ts-nocheck
import { Plugin } from '/Users/guanwenchao/Documents/ChatGPT/h5自建站/node_modules/.pnpm/@umijs+runtime@3.5.43_react@16.14.0/node_modules/@umijs/runtime';

const plugin = new Plugin({
  validKeys: ['modifyClientRenderOpts','patchRoutes','rootContainer','render','onRouteChange','__mfsu','dva','getInitialState','initialStateConfig','request',],
});

export { plugin };
